export const CHECK_URL = 'EXT/ADD/CHECK_URL'
export const STEP_BACK = 'EXT/ADD/STEP_BACK'
export const SUBMIT = 'EXT/ADD/SUBMIT'



// WEBPACK FOOTER //
// ./src/extAdd/AddExtensionActionTypes.js